<template>
  <v-data-table :headers="headers" :items="importedDocList" class="elevation-0">
    <template v-slot:items="props">
      <td class="text-xs-left">{{ props.item.fileName }}</td>
      <td class="text-xs-left">{{ props.item.created_at | moment("DD/MM/YYYY")}}</td>
      <td class="text-xs-left">
        <v-icon small class="miniPrimary light-blue--text text--darken-4 pr-1">cloud_download</v-icon>
        <a
          class="caption light-blue--text text--darken-4"
          target="_blank"
          :href="props.item.path_file"
        >{{ props.item.fileName }}</a>
        <v-icon small class="mx-2" @click="editItem(props.item.id)" v-if="!disableFields">edit</v-icon>
        <v-icon small class="mx-0" @click="confirmDelFileDocs(props.item)" v-if="!disableFields">delete</v-icon>
      </td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'ImportedDocsList',

  props: {
    disableFields: { type: Boolean, default: false },
    importedDocList: Array,
    confirmDelFileDocs: Function,
    editItem: Function
  },

  data () {
    return {
      headers: [
        {
          text: 'Nome do arquivo',
          align: 'left',
          sortable: true,
          value: 'fileName'
        },
        {
          text: 'Data do anexo',
          value: 'created_at',
          align: 'left',
          sortable: true
        },
        {
          text: 'Link do arquivo',
          align: 'left',
          value: 'path_file',
          sortable: false
        }
      ]
    }
  }
}
</script>

<style>
</style>
